/**
 * Rango de fechas por omisión de las listas (Folio, Remisión, Entradas de
 * material, Incidencias): el MES ACTUAL. El usuario lo amplía con el filtro
 * "Periodo".
 */
export function currentMonthStart(): Date {
  const t = new Date();
  return new Date(t.getFullYear(), t.getMonth(), 1, 0, 0, 0, 0);
}

export function currentMonthEnd(): Date {
  const t = new Date();
  return new Date(t.getFullYear(), t.getMonth() + 1, 0, 23, 59, 59, 999);
}

/**
 * Convierte las fechas que manda el API a milisegundos. El API guarda
 * `createdOn` como "MM/DD/YYYY, HH:mm:ss" (hora de México); también acepta ISO.
 * Se parsea a mano porque Safari/Firefox no entienden el formato con coma.
 */
export function parseApiDate(value: any): number {
  if (value instanceof Date) return value.getTime();
  const str = String(value ?? '').trim();
  const m = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:,?\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?/);
  if (m) {
    return new Date(Number(m[3]), Number(m[1]) - 1, Number(m[2]), Number(m[4] ?? 0), Number(m[5] ?? 0), Number(m[6] ?? 0)).getTime();
  }
  return new Date(str.replace(' ', 'T')).getTime();
}

/**
 * ¿La fecha cae dentro del rango? Sin límites = pasa.
 * `keepUndated`: un registro sin fecha (o con fecha ilegible) se muestra en
 * lugar de desaparecer (p. ej. borradores).
 */
export function inDateRange(value: any, start: Date | null | undefined, end: Date | null | undefined, keepUndated = false): boolean {
  if (!start && !end) return true;
  if (!value) return keepUndated;
  const d = parseApiDate(value);
  if (isNaN(d)) return keepUndated;
  if (start) {
    const s = new Date(start); s.setHours(0, 0, 0, 0);
    if (d < s.getTime()) return false;
  }
  if (end) {
    const e = new Date(end); e.setHours(23, 59, 59, 999);
    if (d > e.getTime()) return false;
  }
  return true;
}
